export const companyAddressMode = {
   storedAddress: 'storedAddress',
   customAddress: 'customAddress'
}
